import { Flex } from "antd";
import { FC } from "react";
import { Point } from "tm-shared/types";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

type PointInfoProps =
    | {
          address?: string;
          fop?: string;
      }
    | {
          point: Point;
      };

export const PointInfo: FC<PointInfoProps> = (props) => {
    const address =
        "point" in props
            ? props.point.market.building.address.name
            : props.address ?? "";
    const fop =
        "point" in props ? props.point.market.contragent.name : props.fop ?? "";

    return (
        <Flex vertical gap={4}>
            {fop && <PrimaryText fontSize={16}>{fop}</PrimaryText>}

            {address && <SecondaryText>{address}</SecondaryText>}
        </Flex>
    );
};
